module.exports = __webpack_public_path__ + "resources/img/img_cloud_architecture_04_en.5d6bfb40e468c01ce009b0cf790e8351.png";